<div [formGroup]="form">
  <div class="section-container" id="precos">
    <div class="section-title">
      <mat-icon>attach_money</mat-icon>
      <span>Preços</span>
    </div>

    <div class="row">
      <div class="col-12 col-md-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Markup Padrão (%)</mat-label>
          <input matInput formControlName="markupPadrao" [currencyMask]="percentageMask" />
          @if (form.get('markupPadrao')?.hasError('required')) {
            <mat-error>Informe o markup padrão</mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div formArrayName="precos">
      <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
        <h4 class="subsection-title mb-0">Listas de Preço</h4>
        <button mat-button type="button" (click)="addPrecoRow()"><mat-icon>add</mat-icon> Adicionar</button>
      </div>

      @for (item of precos.controls; track item; let i = $index) {
        <div [formGroupName]="i" class="form-row-separator">
          <div class="row">
            <div class="col-10 col-md-11">
              <div class="row">
                <!-- Lista de Preços -->
                <div class="col-6 col-lg-5">
                  @if (getListaPrecosDisponiveis(i)) {
                    <app-select-pesquisavel
                      [offlineList]="getListaPrecosDisponiveis(i)"
                      [control]="getControl(item, 'idListaPreco')"
                      idField="id"
                      [disabled]="
                        isListaPadrao(getControl(item, 'idListaPreco').value) ||
                        isListaSelecaoAutomatica(getControl(item, 'idListaPreco').value)
                      "
                      nameField="descricao"
                      label="Lista de Preços"
                      placeholder="Selecione..."
                      (selectionChange)="onListaPrecoChange(i)">
                    </app-select-pesquisavel>
                  }
                </div>

                <!-- Preço de Venda -->
                <div class="col-6 col-lg-3">
                  <mat-form-field appearance="outline">
                    <mat-label>Preço</mat-label>
                    <input matInput formControlName="precoVenda" [currencyMask]="dynamicCurrencyMask" />
                    @if (getControl(item, 'precoVenda').hasError('valorMaiorQueZero')) {
                      <mat-error>Informe um valor maior que zero</mat-error>
                    }
                    @if (calculandoPreco.has(i)) {
                      <mat-spinner matSuffix diameter="16"></mat-spinner>
                    }
                    @if (getControl(item, 'precoVenda').disabled && !calculandoPreco.has(i)) {
                      <mat-icon
                        matSuffix
                        [matTooltip]="
                          isKit && isListaPadrao(getControl(item, 'idListaPreco').value)
                            ? (isPrecoKitFixo
                                ? 'Reflete o valor informado em Preço de venda no kit'
                                : 'Calculado pela soma dos componentes do kit')
                            : 'Calculado automaticamente pela regra da lista'
                        "
                        class="lock-icon"
                        >lock</mat-icon
                      >
                    }
                  </mat-form-field>
                </div>

                <!-- Informações da Lista (Método, Vigência, Promoção) -->
                <div class="col-5 col-lg-2">
                  @if (getListaPrecoById(getControl(item, 'idListaPreco').value); as lista) {
                    <div>
                      <div class="lista-info-metodo">{{ lista.metodoAjuste }}</div>
                      @if (getDetalhesAjuste(lista.id)) {
                        <small>
                          {{ getDetalhesAjuste(lista.id) }}
                        </small>
                      }
                    </div>
                  }
                </div>
                <div class="col-5 col-lg-2">
                  @if (getListaPrecoById(getControl(item, 'idListaPreco').value); as lista) {
                    <div class="d-flex gap-2 flex-wrap">
                      @if (lista?.listaPreco?.dataInicioVigencia; as dtIni) {
                        <small> De: {{ dtIni | date: 'dd/MM/yyyy' }} </small>
                      }
                      @if (lista?.listaPreco?.dataTerminoVigencia; as dtFim) {
                        <small> Até: {{ dtFim | date: 'dd/MM/yyyy' }} </small>
                      }
                      @if (lista?.listaPreco?.isPromocao) {
                        <span class="status-badge badge-verde"> PROMOÇÃO </span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="col-2 col-md-1 produto-grid-delete-col">
              @if (
                !isListaPadrao(getControl(item, 'idListaPreco').value) &&
                !isListaSelecaoAutomatica(getControl(item, 'idListaPreco').value)
              ) {
                <button
                  mat-icon-button
                  class="delete-button produto-grid-delete-button"
                  type="button"
                  (click)="removePrecoRow(i)"
                  matTooltip="Remover">
                  <mat-icon class="material-symbols-outlined">delete</mat-icon>
                </button>
              }
            </div>
          </div>
        </div>
      }

      @if (precos.length === 0) {
        <app-empty-state icon="attach_money" title="Nenhum preço cadastrado."
          subtitle="Adicione uma lista de preços para definir o valor de venda deste produto.">
        </app-empty-state>
      }
    </div>
  </div>
</div>
